import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import {
  FilterBar,
  FilterError,
  FilterField,
  FilterGroup,
  FilterLabel,
  FilterSeparator,
} from './styled';

// Filtro dos relatorios do menu Cobranca, entregue ao TableWrapper pela prop
// `filters`. O periodo (de/ate, `AAAA-MM-DD`) vai para a query do endpoint;
// `options` e opcional e desenha um seletor ao lado, como o da Carteira.
// Trocar qualquer um dos dois reconsulta o endpoint. `children` entra no fim
// da barra, para o filtro proprio de um relatorio (ex.: o operador).
export default function PeriodFilter({
  label = 'Período',
  period,
  onChangePeriod,
  invalid,
  optionsLabel,
  options,
  value,
  onChange,
  children,
}) {
  return (
    <FilterBar>
      <FilterGroup>
        <FilterLabel>{label}</FilterLabel>
        <FilterField>
          <Input
            holder
            small
            transparent
            type="date"
            value={period?.from || ''}
            onChange={(e) =>
              onChangePeriod({ ...period, from: e.target.value })
            }
          />
        </FilterField>
        <FilterSeparator>até</FilterSeparator>
        <FilterField>
          <Input
            holder
            small
            transparent
            type="date"
            value={period?.to || ''}
            onChange={(e) => onChangePeriod({ ...period, to: e.target.value })}
          />
        </FilterField>
        {!invalid ? null : <FilterError>Período inválido</FilterError>}
      </FilterGroup>
      {!options?.length ? null : (
        <FilterGroup>
          {!optionsLabel ? null : <FilterLabel>{optionsLabel}</FilterLabel>}
          {options.map((option) => (
            <Button
              key={option.value}
              color={value === option.value ? 'blue' : 'lightgrey'}
              small
              nospace
              width="auto"
              onClick={() => value !== option.value && onChange(option.value)}
            >
              {option.label}
            </Button>
          ))}
        </FilterGroup>
      )}
      {children}
    </FilterBar>
  );
}
